import React from 'react';
import ConnectingLoaderOld from '../../../assets/images/connecting-loader.svg';

export const ConnectingLoaderIcon = (props) => {
  return <ConnectingLoaderOld {...props} className='spin' />;
};
